import { INVOICE_ROW_UPDATE, INVOICE_SELECT_IDS, INVOICE_UPDATE_OPEN, UPDATE_CURRENT_TICKET } from '../mutationTypes';

const initState = {
  open: false,
  activeRow: {},
  selectIds: [],
  currentTicket: {},
};
const getters = {};
const state = {
  ...JSON.parse(JSON.stringify(initState)),
};

const mutations = {
  [INVOICE_ROW_UPDATE](states, newValue = initState.activeRow) {
    const activeRow = JSON.parse(JSON.stringify(newValue));
    Object.assign(states, { activeRow });
  },
  [INVOICE_SELECT_IDS](states, newValue = initState.selectIds) {
    Object.assign(states, { selectIds: newValue });
  },
  [UPDATE_CURRENT_TICKET](states, newValue = initState.currentTicket) {
    const currentTicket = JSON.parse(JSON.stringify(newValue));
    Object.assign(states, { currentTicket });
  },
  [INVOICE_UPDATE_OPEN](states, newValue = false) {
    Object.assign(states, { open: newValue });
  },
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
